/* eslint-disable import/no-cycle */
import axios from 'axios';
import { postJwtToken } from '../services/user.service';
import { ROUTES } from '../constants';

const forceLogout = async () => {
  sessionStorage.clear();
  window.location.href = `${ROUTES.HOME}`;
};

const axiosInstance = axios.create({
  baseURL: '/',
});

/**
 * Interceptor para las peticiones al backend, en caso de tener
 * informada una credencial en el sessionStorage esta se adjunta
 * en la cabecera para ser enviada en cada petición.
 */
axiosInstance.interceptors.request.use(
  async (config) => {
    const conf = config;
    const jwt = sessionStorage.getItem('jwtToken');

    if (jwt) {
      conf.headers = {
        ...conf.headers,
        Authorization: `Bearer ${jwt}`,
      };
    }
    return conf;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor para las respuestas del backend, en caso que la
 * petición devuelva un código de error HTTP 401 porque carece
 * de credenciales válidas de autenticación se va a buscar una
 * nueva credencial y se lanza una nueva petición con la
 * credencial actualizada.
 *
 * En caso de error a la hora de ir a buscar una nueva credencial
 * está limpia el sessionStorage y redirige a una página de error.
 */
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401 && sessionStorage.getItem('jwtToken')) {
      const storageRefreshToken = sessionStorage.getItem('refreshToken');
      const { status, data: result } = await postJwtToken({ data: { refreshToken: storageRefreshToken } });
      if (status === 200) {
        const { refreshToken, jwtToken } = result;
        sessionStorage.setItem('jwtToken', jwtToken);
        sessionStorage.setItem('refreshToken', refreshToken);
        const config = error?.config;
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${jwtToken}`,
        };
        return axios(config);
      }
    }

    if (error?.response?.status === 403) {
      forceLogout();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
